import * as React from "react"
import { ToastContextSetState } from "components/toast"
import { ToastData } from "components/toast/ToastProvider"

function useToast() {
	const dispatch = React.useContext(ToastContextSetState)

	function showToast(toast: ToastData, { delay = 0, timeout = 3000 } = {}) {
		const id = Date.now() + toast.header

		function show() {
			dispatch({
				type: "add",
				payload: { id, ...toast },
			})
		}

		if (delay === 0) {
			show()
		} else {
			// register show
			setTimeout(show, delay)
		}

		// register hide
		setTimeout(() => {
			dispatch({
				type: "hide",
				id,
			})
		}, timeout + delay)

		// register remove from dom after hide
		setTimeout(() => {
			dispatch({
				type: "delete",
				id,
			})
		}, timeout + 3000 + delay)
	}

	return showToast
}

export default useToast
